<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit FAQ</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/faqs" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
          <form @submit.prevent="updateFaq" v-if="faq">
            <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12" v-if="faqSections.length">
                    <fg-select
                      v-model="faq.faqHeaderId"
                      label="Select Section Header"
                      v-validate="rules.faqHeaderId"
                      data-vv-name="Section Header"
                      cus-name="Section Header"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="faqSections"
                      selectedKey="faqHeaderId"
                      showLabel="faqHeader"
                    >
                    </fg-select>
                  </div>
                  <div class="col-md-5">
                    <fg-input type="text"
                              v-model="faq.faqImageUrl"
                              label="Image URL"
                              placeholder="Enter Image URL"
                              data-vv-name="imageUrl"
                              cus-name="imageUrl"
                              v-validate="rules.faqImageUrl"
                              :has-errors="errors"
                              :is-fields="fields"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-5">
                    <fg-input type="text"
                              v-model="faq.faqVideoUrl"
                              label="Video Code"
                              placeholder="Enter Video Code"
                              data-vv-name="Video Code"
                              cus-name="Video Code"
                              v-validate="rules.faqVideoUrl"
                              :has-errors="errors"
                              :is-fields="fields"
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="faq.question"
                                  label="Question"
                                  placeholder="Enter Question"
                                  v-validate="rules.question"
                                  data-vv-name="Question"
                                  cus-name="Question"
                                  :has-errors="errors"
                                  :is-fields="fields">
                    </fg-text-area>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area type="text"
                                  v-model="faq.response"
                                  label="Answer"
                                  placeholder="Enter Answer"
                                  v-validate="rules.response"
                                  data-vv-name="Answer"
                                  cus-name="Answer"
                                  :has-errors="errors"
                                  :is-fields="fields">
                    </fg-text-area>
                  </div>
                  <div class="col-3" v-if="status.length">
                    <fg-select
                      v-model="faq.active"
                      label="isActive"
                      v-validate="rules.active"
                      data-vv-name="active"
                      cus-name="active"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="status"
                      selectedKey="id"
                    >
                    </fg-select>
                  </div>
                </div>

                <!--<div class="col-3" v-if="status.length">-->
                <!--<fg-select-->
                <!--v-model="article.active"-->
                <!--label="isActive"-->
                <!--v-validate="rules.active"-->
                <!--data-vv-name="active"-->
                <!--cus-name="active"-->
                <!--:has-errors="errors"-->
                <!--:is-fields="fields"-->
                <!--:list="status"-->
                <!--selectedKey="id"-->
                <!--&gt;-->
                <!--</fg-select>-->
                <!--</div>-->
              </div>

              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                  Update FAQ
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditFaq',
        created (){
            this.fetchFAQSections();
        this.$store.dispatch('GETSELECTEDFAQ', this.$route.params.id).then(() =>{
            this.faq = this.selectedFaq;;
        })
    },
    data () {
        let dateTime = new Date();
        return {
            faq: this.selectedFaq || {},
          rules: {
            faqHeaderId: {required : true},
            question: {required: true},
            response: {required : true}
          },
          faqSections: [],
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      fetchFAQSections () {
        this.$store.dispatch('FETCH_FAQSECTIONS')
          .then((res) => {
            res.unshift({faqHeader: "Select an option"});
            this.faqSections = res;
            console.log('sections', this.faqSections)
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
        updateFaq () {
          this.$validator.validateAll().then((result) => {
            if(result){
              let updateFaq = () =>{
                this.$store.dispatch('UPDATE_FAQ', this.faq)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'FAQ is successfully updated', 'success', ()=>this.$router.push('/admin/faqs'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_FAQ API error : ", err);
                  })
              };
              updateFaq();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'faqs', 'selectedFaq']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Faqs/EditFaq.vue